import React from 'react';
import {
	defineMessages,
	useIntl,
} from 'react-intl';

import DonutPagesChart from '../components/DonutPagesChart';



const messages = defineMessages({
	indexableNo: {
		id: 'ui.contentOverview.indexable.no',
	},
	indexableNotApplicable: {
		id: 'ui.general.notApplicable',
	},
	indexableYes: {
		id: 'ui.contentOverview.indexable.yes',
	},
});



type Props = {
	data: Array<{
		count: number;
		percentage: number;
		value: string;
	}>;
	field: string;
};



const IndexableChart: React.FC<Props> = (props) => {
	const {
		data,
		field,
	} = props;

	const intl = useIntl();

	const categories = [
		{
			value: 'yes',
			label: intl.formatMessage(messages.indexableYes),
			color: '#42CC67',
		},
		{
			value: 'no',
			label: intl.formatMessage(messages.indexableNo),
			color: '#FF743B',
		},
		{
			value: 'not_applicable',
			label: intl.formatMessage(messages.indexableNotApplicable),
			color: '#8595A6',
		},
	];

	return (
		<DonutPagesChart
			categories={categories}
			data={data}
			name={field}
			percentageFactor={100}
		/>
	);
};



export default React.memo(IndexableChart);
